import { toast } from '@/components/ui/use-toast'
import i18n from '@/i18n'

export function toastSentryError(id: string | null) {
  toast({
    title: i18n.t('error_toast.title'),
    description: (
      <div>
        <p>{i18n.t('error_toast.description')}</p>
        <p>
          {i18n.t('error_toast.error_id')} {id}
        </p>
      </div>
    ),
    variant: 'destructive',
    duration: 10000
  })
}
